module.exports = __webpack_public_path__ + "img/img70.d061e4bc.svg";